import React, {createContext, useState, useRef} from 'react'
export const AppContext = createContext()

/**
 * Initial state for the revamped portal flow.
 * This is NAMESPACED to prevent collision with legacy state.
 *
 * ISOLATION RULE:
 * - Legacy components use: shareYourInterests, searchOpportunities, selectedSubject, etc.
 * - Revamp components use: revampState, setRevampState ONLY
 */
const INITIAL_REVAMP_STATE = {
	// Flow control
	currentStep: 'hero', // 'hero' | 'mode' | 'city' | 'cluster' | 'availability' | 'subjects' | 'summary'
	flowMode: null, // 'offline' | 'online' | null

	// User selections (no limits on clusters, up to 5 subjects)
	selections: {
		mode: null, // 'Offline' | 'Online' | null
		city: null,
		clusters: [], // No limit (was 3 in legacy)
		availability: [],
		subjects: {
			available: [],
			waitlist: [],
		},
		confirmedSteps: {
			mode: false,
			city: false,
			cluster: false,
			availability: false,
		},
	},

	// Pre-filled from URL params (e.g., from map navigation)
	prefilledCity: null,
	prefilledCluster: null,

	// Scroll trigger for cross-component communication (Header -> Content)
	scrollTrigger: null,

	// UI state
	isTransitioning: false,
}

function Context({children}) {
	// ============================================
	// LEGACY STATE (DO NOT MODIFY)
	// These are used by Header, Filter, Opportunities, Footer
	// ============================================
	const [shareYourInterests, setShareYourInterests] = useState(true)
	const [searchOpportunities, setSearchOpportunities] = useState(false)
	const [selectedUpcomingCluster, setSelectedUpcomingCluster] = useState([])
	const selectedSubject = useRef([])
	const selectedData = useRef([])

	// ============================================
	// REVAMP STATE (NEW - Phase 5)
	// These are ONLY used by RevampedVolunteerPortal and its children
	// ============================================
	const [revampState, setRevampState] = useState(INITIAL_REVAMP_STATE)

	// Helper to update nested revamp state
	const updateRevampSelections = updates => {
		setRevampState(prev => ({
			...prev,
			selections: {
				...prev.selections,
				...updates,
			},
		}))
	}

	// Helper to reset revamp state
	const resetRevampState = () => {
		setRevampState(INITIAL_REVAMP_STATE)
	}

	return (
		<AppContext.Provider
			value={{
				// Legacy state (unchanged)
				shareYourInterests,
				setShareYourInterests,
				searchOpportunities,
				setSearchOpportunities,
				selectedSubject,
				selectedData,
				selectedUpcomingCluster,
				setSelectedUpcomingCluster,

				// Revamp state (new)
				revampState,
				setRevampState,
				updateRevampSelections,
				resetRevampState,
			}}
		>
			{children}
		</AppContext.Provider>
	)
}

export default Context
